<div class='container-fluid content-margin-cms'>
  <div class='row m-0'>
    <div class='col-12 col-sm-3 col-lg-2 m-0 p-0 h-100 collapse show mt-3' id='collapseExample'>
      <nav class='nav flex-column sticky-top'>
        <li class='nav-item'>
          <span class='dashboard backPrimary'><i class='fa fa-list-alt me-1' aria-hidden='true'></i>Dashboard</span>
        </li>
        <li class='nav-item' *ngFor='let group of cmsRoutes'>
          <div *ngIf='group.groupId==="item-0"'>
            <ul class='nav flex-column' *ngFor='let route of group.routes'>
              <li class='nav-item'>
                <a class='nav-link' [routerLink]='route.routerLink' routerLinkActive='menuActive'>{{ route.routerName }}</a>
              </li>
            </ul>
          </div>
          <a *ngIf='group.groupId!=="item-0"' class='nav-link dropdown-toggle flex-nowrap bottomlinegray' data-bs-toggle='collapse' [attr.data-bs-target]="'#' + group.groupId" [attr.aria-expanded]='false' [attr.aria-controls]='group.groupId'>{{ group.groupTitle }}</a>
          <div *ngIf='group.groupId!=="item-0"' [id]='group.groupId' class='collapse show' [attr.data-bs-parent]='null'>
            <ul class='nav flex-column' *ngFor='let route of group.routes'>
              <li class='nav-item'>
                <a class='nav-link ps-5' [routerLink]='route.routerLink' routerLinkActive='menuActive'>{{ route.routerName }}</a>
              </li>
            </ul>
          </div>
        </li>
      </nav>
    </div>
    <div class='col-12 col-sm-9 col-lg-10 p-0'>
      <div class='row m-0'>
        <div class='col-12 pe-0'>
          <h3 class='sticky-top mt-3'>
            <button class='btn sticky-top' data-bs-toggle='collapse' href='#collapseExample' role='button'>
              <i class='fa fa-bars' aria-hidden='true'></i>
            </button>
            {{ cmsTitle }}
          </h3>
        </div>
        <div class='col-12 pe-0'>
          <hr />
          <router-outlet></router-outlet>
        </div>
      </div>
    </div>
  </div>
</div>

